import { path } from 'ramda'
import { useSelector } from 'react-redux'

const useLivScore = () => {
  return useSelector(path(['profile', 'liv_score']))
}

export default useLivScore
